import { useEffect, useState } from 'react';
import { Snackbar, Box, Button, IconButton } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useUpdate } from '../../context/UpdateContext';

// 새 배포가 감지되면 우하단에 알림을 띄우고, "업데이트" 버튼 한 번 클릭으로 reload 한다.
// 사용자가 X 로 닫아도 hasUpdate 자체는 유지되므로 라우트 이동/idle 자동 reload 는 그대로 동작한다.

const slideIn = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const NotifierBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  background: '#0F7F85',
  color: '#fff',
  padding: '12px 12px 12px 18px',
  borderRadius: 12,
  boxShadow: '0 6px 24px rgba(0, 0, 0, 0.18)',
  minWidth: 320,
  animation: `${slideIn} 0.25s ease-out`,
});

const IconWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: '50%',
  background: 'rgba(255, 255, 255, 0.2)',
  flexShrink: 0,
  '& svg': {
    fontSize: 20,
    color: '#fff',
  },
});

const Message = styled('span')({
  flex: 1,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
});

const UpdateButton = styled(Button)({
  background: '#fff',
  color: '#0F7F85',
  fontWeight: 600,
  fontSize: 13,
  padding: '6px 14px',
  borderRadius: 8,
  minWidth: 0,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  '&:hover': {
    background: '#f0f9f9',
    boxShadow: 'none',
  },
});

const CloseBtn = styled(IconButton)({
  color: '#fff',
  padding: 4,
  '&:hover': {
    background: 'rgba(255, 255, 255, 0.15)',
  },
});

const UpdateBadge = () => {
  const { hasUpdate } = useUpdate();
  const [open, setOpen] = useState(false);

  // hasUpdate 가 true 로 바뀔 때만 자동으로 알림을 연다 (사용자가 닫은 후엔 다시 안 뜸)
  useEffect(() => {
    if (hasUpdate) setOpen(true);
  }, [hasUpdate]);

  if (!hasUpdate) return null;

  const handleReload = () => window.location.reload();
  const handleClose = () => setOpen(false);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ bottom: 24, right: 24 }}>
      <NotifierBox>
        <IconWrapper>
          <AutorenewIcon />
        </IconWrapper>
        <Message>새 버전이 있습니다</Message>
        <UpdateButton onClick={handleReload}>업데이트</UpdateButton>
        <CloseBtn onClick={handleClose} aria-label="close">
          <CloseIcon fontSize="small" />
        </CloseBtn>
      </NotifierBox>
    </Snackbar>
  );
};

export default UpdateBadge;
